import { findStatuses } from '~/Api/DataSourceStatus';
import { Result } from '~/Api/DataSourceStatus/findStatuses';
import { invokeApi } from '~/ApiClient';
import { handleError } from '~/ErrorHandler';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';

export function fetchStatuses(): ThunkAction<Promise<Result | null>, any> {
	return async (dispatch) => {
		const request = dispatch(invokeApi(findStatuses));
		dispatch({ type: ActionTypes.request, request });

		try {
			const response = await request;
			dispatch({
				type: ActionTypes.receive,
				request,
				statuses: response.items,
			});
			return response;
		} catch (error) {
			dispatch({ type: ActionTypes.receive, request, statuses: null });
			dispatch(handleError(error));
			return null;
		}
	};
}

export function fetchStatusesIfNeeded(): ThunkAction<Promise<Result>, any> {
	return async (dispatch, getState) => {
		return getState().dataSourceStatus.request || dispatch(fetchStatuses());
	};
}
